import React from "react";
import { useTranslation } from "react-i18next";

import packageJson from "../../../package.json";

import { Box, Container, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const AccessibilityTooltip = React.lazy(() => import("../../components/_common/AccessibilityTooltip"));

const useStyles = makeStyles((theme) => ({
    appBarBottom: {
        border: "none",
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(0),
    },
    appBarBottomCopyright: {
        backgroundColor: "#363636",
        color: theme.palette.primary.contrastText,
        textAlign: "center",
        fontSize: "0.675rem",
    },
    logoBottom: {
        margin: theme.spacing(0, 4, 0, 0),
        // maxHeight: 56,
        height: "clamp(76px, 10vw,96px)",
        [theme.breakpoints.down("sm")]: {
            // margin: "16px 16px 16px -57px",
            margin: "0px 16px 16px 16px",
        },
    },
    footerItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 160,
        fontSize: "0.75rem",
        [theme.breakpoints.down("sm")]: {
            minHeight: 64,
            fontSize: "0.75rem",
            justifyContent: "flex-start",
            padding: "8px 0 16px 73px",
            borderBottom: `1px solid ${theme.palette.secondary.light}`,
        },
    },
    footerHolder: {
        // backgroundColor: theme.palette.secondary.main,
        padding: 0,
        marginTop: 40,
    },
    footer: {
        minHeight: 120,
        maxWidth: 1472,
        fontSize: "clamp(14px, 1vw, 1.125rem)",
    },
    link: {
        fontSize: "clamp(14px, 1vw, 1.125rem)",
        fontWeight: 400,
        color: "#001D77",
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    linkLarge: {
        fontSize: "clamp(14px, 1vw, 1.125rem)",
        fontWeight: 400,
        color: "#001D77",
        textDecoration: "none",
        [theme.breakpoints.down("sm")]: {
            whiteSpace: "nowrap",
            marginBottom: 8,
            display: "block",
        },
        "&:hover": {
            textDecoration: "underline",
        },
    },
    copyright: {
        display: "block",
        fontSize: "clamp(14px, 1vw, 1.125rem)",
        whiteSpace: "nowrap",
        [theme.breakpoints.down("sm")]: {
            whiteSpace: "normal",
        },
    },
    footerAddress: {
        display: "flex",
        alignItems: "flex-start",
    },
    footerLinks: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 40,
        fontSize: "0.88888889rem",
        [theme.breakpoints.down("sm")]: {
            marginTop: 16,
        },
        "& ul": {
            padding: 0,
            "& li": {
                listStyle: "none",
                textAlign: "center",
                [theme.breakpoints.down("sm")]: {
                    textAlign: "left",
                },
            },
        },
    },
    sosialLi: {
        maxWidth: 24,
    },
    socialLink: {
        color: "inherit",
        textDecoration: "inherit",
        display: "block",
    },
    version: {
        fontSize: "clamp(10px, 1rem, 11px)",
        color: "#000000",
        margin: theme.spacing(1, 0, 4, 0),
        textAlign: "right",
        lineHeight: 1,
    },
}));

const Footer = () => {
    const classes = useStyles();
    const { i18n, t } = useTranslation();
    return (
        <React.Fragment>
            <Container maxWidth={false} className={classes.footerHolder}>
                <Container maxWidth={false} className={classes.footer}>
                    <Grid container spacing={1} id={"global-footer"} tabIndex={-1} 
                    // role={"contentinfo"}
                    >
                        <Grid item xs={12} md={3} className={classes.footerAddress}>
                            <img src={`/logos/logo-gus-small.svg`} alt="GUS logo" className={classes.logoBottom} />
                            <Box>
                                <b>{t("Główny Urząd Statystyczny")}</b>
                                <br />
                                {t("Aleja Niepodległości 208")}
                                <br />
                                {t("00-925 Warszawa")}
                                <br />
                                <a
                                    href="https://stat.gov.pl"
                                    target="_self"
                                    rel="noopener noreferrer"
                                    className={classes.link}
                                >
                                    {t("Przejdź do Portalu GUS")}
                                </a>
                            </Box>
                        </Grid>

                        {/* <Grid item xs={12} md={3} className={classes.footerItem0}>
                            <Box>
                                Godzina pracy Urzędu: <b>8:15-16:15</b>
                                <br />
                                Kancelaria: <b>+48 22 608 30 00</b>
                                <br />
                                <b>kancelariaogolnaGUS@stat.gov.pl</b>
                                <br />
                                <a
                                    href="mailto:kancelariaogolnaGUS@stat.gov.pl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={classes.link}
                                >
                                    Elektroniczna Skrzynka Podawcza
                                </a>
                            </Box>
                        </Grid> */}
                    </Grid>

                    <Grid container spacing={1} style={{ marginTop: 16, marginBottom: 0 }}>
                        <Grid
                            item
                            xs={12}
                            md={2}
                            className={classes.footerItem0}
                            style={{
                                paddingLeft: 0,
                                flexDirection: "column",
                                marginBottom: 0,
                                minWidth: 312,
                            }}
                        >
                            <Grid
                                container
                                spacing={0}
                                alignContent={"center"}
                                style={{
                                    paddingLeft: 0,
                                    margin: 0,
                                    textAlign: "center",
                                    listStyleType: "none",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    minHeight: 28,
                                }}
                                component={"ul"}
                            >
                                <Grid item xs component={"li"} className={classes.sosialLi}>
                                    <AccessibilityTooltip
                                        arrow={false}
                                        placement="top"
                                        title={t(
                                            `Przejdź na profil GUS na X{{kr}} Strona otworzy się w nowej zakładce{{kr}}`,
                                            { kr: "." }
                                        )}
                                    >
                                        <a
                                            href="https://twitter.com/GUS_STAT"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={classes.socialLink}
                                            aria-label={t(
                                                `Przejdź na profil GUS na X{{kr}} Strona otworzy się w nowej zakładce{{kr}}`,
                                                { kr: "." }
                                            )}
                                        >
                                            <img src={"/icons/socials/x.svg"} alt={"X logo"} />
                                        </a>
                                    </AccessibilityTooltip>
                                </Grid>

                                <Grid item xs component={"li"} className={classes.sosialLi}>
                                    <AccessibilityTooltip
                                        arrow={false}
                                        placement="top"
                                        title={t(
                                            `Przejdź na profil GUS na YouTube{{kr}} Strona otworzy się w nowej zakładce{{kr}}`,
                                            { kr: "." }
                                        )}
                                    >
                                        <a
                                            href="https://www.youtube.com/channel/UC0wiQMElFgYszpAoYgTnXtg/featured"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={classes.socialLink}
                                            aria-label={t(
                                                `Przejdź na profil GUS na YouTube{{kr}} Strona otworzy się w nowej zakładce{{kr}}`,
                                                { kr: "." }
                                            )}
                                        >
                                            <img src={"/icons/socials/youtube.svg"} alt={"Youtube logo"} />
                                        </a>
                                    </AccessibilityTooltip>
                                </Grid>

                                <Grid item xs component={"li"} className={classes.sosialLi}>
                                    <AccessibilityTooltip
                                        arrow={false}
                                        placement="top"
                                        title={t(
                                            `Przejdź na profil GUS na LinkedIn{{kr}} Strona otworzy się w nowej zakładce{{kr}}`,
                                            { kr: "." }
                                        )}
                                    >
                                        <a
                                            href="https://www.linkedin.com/company/532930"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={classes.socialLink}
                                            aria-label={t(
                                                `Przejdź na profil GUS na LinkedIn{{kr}} Strona otworzy się w nowej zakładce{{kr}}`,
                                                { kr: "." }
                                            )}
                                        >
                                            <img src={"/icons/socials/linkedin.svg"} alt={"LinkedIn logo"} />
                                        </a>
                                    </AccessibilityTooltip>
                                </Grid>

                                <Grid item xs component={"li"} className={classes.sosialLi}>
                                    <AccessibilityTooltip
                                        arrow={false}
                                        placement="top"
                                        title={t(
                                            `Przejdź na profil GUS na Facebook{{kr}} Strona otworzy się w nowej zakładce{{kr}}`,
                                            { kr: "." }
                                        )}
                                    >
                                        <a
                                            href="https://www.facebook.com/GlownyUrzadStatystyczny/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={classes.socialLink}
                                            aria-label={t(
                                                `Przejdź na profil GUS na Facebook{{kr}} Strona otworzy się w nowej zakładce{{kr}}`,
                                                { kr: "." }
                                            )}
                                        >
                                            <img src={"/icons/socials/facebook.svg"} alt={"Facebook logo"} />
                                        </a>
                                    </AccessibilityTooltip>
                                </Grid>

                                <Grid item xs component={"li"} className={classes.sosialLi}>
                                    <AccessibilityTooltip
                                        arrow={false}
                                        placement="top"
                                        title={t(
                                            `Przejdź na profil GUS na Instagram{{kr}} Strona otworzy się w nowej zakładce{{kr}}`,
                                            { kr: "." }
                                        )}
                                    >
                                        <a
                                            href="https://www.instagram.com/gus_stat/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={classes.socialLink}
                                            aria-label={t(
                                                `Przejdź na profil GUS na Instagram{{kr}} Strona otworzy się w nowej zakładce{{kr}}`,
                                                { kr: "." }
                                            )}
                                        >
                                            <img src={"/icons/socials/instagram.svg"} alt={"Instagram logo"} />
                                        </a>
                                    </AccessibilityTooltip>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md className={classes.footerLinks}>
                            <Grid
                                container
                                spacing={0}
                                component={"ul"}
                                style={{
                                    paddingLeft: 0,
                                    margin: "-4px 0px 0px 0px",
                                    textAlign: "center",
                                    listStyleType: "none",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    minHeight: 28,
                                }}
                            >
                                <Grid item xs={12} md component={"li"}>
                                    <a
                                        href={`${i18n.language === "pl" ? "" : `/${i18n.language}`}/sitemap`}
                                        rel="noopener noreferrer"
                                        className={classes.linkLarge}
                                    >
                                        {t("Mapa strony")}
                                    </a>
                                </Grid>
                                <Grid item xs={12} md component={"li"}>
                                    <a
                                        href={`${
                                            i18n.language === "pl" ? "" : `/${i18n.language}`
                                        }/polityka-prywatnosci`}
                                        rel="noopener noreferrer"
                                        className={classes.linkLarge}
                                    >
                                        {t("Polityka prywatności")}
                                    </a>
                                </Grid>
                                <Grid item xs={12} md component={"li"}>
                                    <a
                                        href={`${i18n.language === "pl" ? "" : `/${i18n.language}`}/deklaracja`}
                                        rel="noopener noreferrer"
                                        className={classes.linkLarge}
                                    >
                                        {t("Deklaracja dostępności")}
                                    </a>
                                </Grid>
                                <Grid item xs={12} md aria-hidden={true} component={"li"}>
                                    <span className={classes.copyright}>
                                        {t("Copyright © 2018-{{date}} Główny Urząd Statystyczny", {
                                            date: new Date().getFullYear(),
                                        })}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* <Grid item xs={12} md className={classes.footerItem0}>
                        </Grid>
                        <Grid item xs={12} md className={classes.footerItem0}>
                        </Grid>
                        <Grid item xs={12} md>
                        </Grid> */}
                    </Grid>

                    <p className={classes.version}>{packageJson.version}</p>
                </Container>
            </Container>
        </React.Fragment>
    );
};

export default Footer;
